import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Prop, Watch, Emit, Component } from 'vue-property-decorator';
import { MagicEmit } from '@gig/magic-common/dist/util';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let InputComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.wheelHandler = null;
  }
  get inputType() {
    if (this.type === "tel") {
      return "number";
    }
    return this.type;
  }
  get pattern() {
    if (this.type === "tel") {
      return "\\d*";
    }
    return this.$attrs.pattern;
  }
  onWheel(event) {
    if (this.type === "tel") {
      event.preventDefault();
    }
  }
  mounted() {
    if (!this.$el) {
      return;
    }
    this.wheelHandler = this.onWheel.bind(this);
    this.$el.addEventListener("wheel", this.wheelHandler, {
      passive: false
    });
  }
  destroyed() {
    if (this.wheelHandler) {
      this.$el.removeEventListener("wheel", this.wheelHandler);
    }
  }
  onChange(event) {
    const target = event.target;
    return target.value;
  }
  onFocusChange() {
    if (this.focused) {
      this.$el.focus();
    }
  }
  onInput(event) {
    const target = event.target;
    return target.value;
  }
  onErase(event) {
    return event;
  }
};
__decorateClass([
  Prop(Boolean)
], InputComponent.prototype, "icon", 2);
__decorateClass([
  Prop(Boolean)
], InputComponent.prototype, "centered", 2);
__decorateClass([
  Prop(Boolean)
], InputComponent.prototype, "small", 2);
__decorateClass([
  Prop(Boolean)
], InputComponent.prototype, "focused", 2);
__decorateClass([
  Prop(String)
], InputComponent.prototype, "type", 2);
__decorateClass([
  MagicEmit("change")
], InputComponent.prototype, "onChange", 1);
__decorateClass([
  Watch("focused", { immediate: true })
], InputComponent.prototype, "onFocusChange", 1);
__decorateClass([
  MagicEmit("input")
], InputComponent.prototype, "onInput", 1);
__decorateClass([
  Emit("erase")
], InputComponent.prototype, "onErase", 1);
InputComponent = __decorateClass([
  Component({
    name: "ui-input",
    inheritAttrs: false
  })
], InputComponent);

export default InputComponent;
